// extracted by mini-css-extract-plugin
module.exports = {"inquiryHeader":"inquiryHeader___3Pl_p","icon":"icon___2G-XP"};